import { useEffect } from "react";
import Nav from "../../components/Nav/Nav";
import Services from "../../components/Services/Services";
import Projects from "../../components/Projects/Projects";
import Skills from "../../components/Skills/Skills";
import Scroll from "../../components/Scroll/Scroll";
import Footer from "../../components/Footer/Footer";

const ServicesPage = () => {
    useEffect(() => {
        document.body.classList.add(localStorage.getItem("lang") || "hy");
        return () => {
            document.body.classList.remove(localStorage.getItem("lang") || "hy");
        };
    }, []);
    return (
        <>
            <Nav />
            <Services />
            <Projects />
            <Skills />
            <Scroll />
            <Footer />
        </>
    );
}

export default ServicesPage;